// extracted by mini-css-extract-plugin
export default {"background":"NotFoundPage_background__Wy2rR","container":"NotFoundPage_container__nwnTh","cardContent":"NotFoundPage_cardContent__I+vwc","textStyle":"NotFoundPage_textStyle__iqKc5"};